import React from "react";
import GLOBAL from "../../global";

import CONSTANT from "../../constants/Constant";

import Footer from "../shared/layout/Footer";
import BodyWithTopMenu from "../shared/layout/BodyWithTopMenu";
import SignUp from "./SignUp";
import leftIcon from "../../assets/img/signin/leftIcon.svg";
import doctorIcon from "../../assets/img/signin/doctor-icon.svg";
import topRoundIcon from "../../assets/img/signin/topRound.svg";
import bottomRoundIcon from "../../assets/img/signin/bottomRound.svg";
// import {redirectTo} from "../shared/chatbotNew/ChatServices";
import routes from "../../constants/Routes";
import SignInSignUpHeaderWrapper from "../shared/layout/HeadWrappers/SignInSignUpHeaderWrapper";
import { useHistory, useLocation } from "react-router-dom";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const SignUpWrapper = () => {
    const history = useHistory();
    const location = useLocation();
    const { isAthleteEnabled } = useTenantFeatures();

    return (
        <div style={isAthleteEnabled ? { backgroundColor: "#1E1F41" } : {}}>
            {/*<MobileHeader/>*/}
            <SignInSignUpHeaderWrapper />
            <BodyWithTopMenu
                pageName={CONSTANT.PAGE_NAME.MY_CALENDAR}
                styleClass={isAthleteEnabled ? "athlete-signup-wrapper" : ""}
            >
                <>
                    {/*<div className="signup-background" aria-hidden="true">*/}
                    {/*    <img src={leftIcon} className='left_icon' alt="" />*/}
                    {/*    <img src={doctorIcon} className='doctorimg' alt="" />*/}
                    {/*    <img src={topRoundIcon} className='halfround' alt="" />*/}
                    {/*    <img src={bottomRoundIcon} className='roundBottom' alt="" />*/}
                    {/*</div>*/}

                    <SignUp
                        imgComponent={
                            <div>
                                <img src={leftIcon} className='left_icon' alt="img" />
                                <img src={doctorIcon} className='doctorimg' alt="img" />
                                <img src={topRoundIcon} className='halfround' alt="img" />
                                <img src={bottomRoundIcon} className='roundBottom' alt="img" />
                            </div>
                        }
                        onClickRedirectToSignIn={() => {
                            const params = new URLSearchParams(location.search);
                            params.set('redirect_from', 'sign_up');
                            history.push(`${routes.signIn}?${params.toString()}`);
                        }}
                    />
                </>
            </BodyWithTopMenu>
            <Footer/>
        </div>
    );
}

export default SignUpWrapper;
